import { CaretRightOutlined, EditOutlined, StopOutlined } from '@ant-design/icons';
import { Button, Col, Layout, Row } from "antd";
import { useEffect, useState } from 'react';
import { getTaskDefExecutionsTaskExec, getTaskExec, startTaskExec, TaskDef, TaskExec } from "../../apis/mgmt/api";
import { Area } from "../common/Area";
import { DataViewProps, readOnly } from "../common/DataView";
import { EditableProps } from '../common/Editable';
import { useStatefulList } from '../common/List';
import { TaskExecPanel } from './TaskExecPanel';
import { useStatefulToggleable, useToggleable } from '../common/Toggleable';
import { TaskExecLog } from './TaskExecLog';
import { TaskExecFileLog } from './TaskExecFileLog';

const { Header, Content } = Layout;

export function TaskDefExecutions(props: 
    DataViewProps<TaskDef> &
    { 
        toggle?: any,
        editable: EditableProps<TaskDef>
    }
) {

    const taskDefId = props.data?.id;
    const title = props.data?.name;

    const oldEditableOnSaved = props.editable.onSaved;
    useEffect(() => {
        props.editable.onSaved = (data: TaskDef, hideAfterSaving: boolean) => {
            oldEditableOnSaved && oldEditableOnSaved(data, hideAfterSaving);
            props.setData(data);
        }
    }, [props.editable]);

    const execList = useStatefulList<TaskExec>(undefined, (data) => {
        if (!data?.id) throw new Error('Id is required');
        return data.id; 
    });
    useEffect(() => {
        if (!taskDefId) execList.setData([]);
        else getTaskDefExecutionsTaskExec(taskDefId).then(data => execList.setData(data.data.content))
    }, [taskDefId]);

    const executeTask = () => {
        taskDefId && startTaskExec(taskDefId).then(response => {
            getTaskExec(response.data).then(response => {
                execList.setData([response.data, ...execList.data || [] ])
            });
        });
    }

    const [ taskExec, setTaskExec ] = useState<TaskExec>();
    const logToggle = useStatefulToggleable(false);
    const onShowLog = (taskExec: TaskExec) => {
        setTaskExec(taskExec);
        logToggle.setVisible(taskExec && true || false);
    }
    const fileLogToggle = useStatefulToggleable(false);
    const onShowFileLog = (taskExec: TaskExec) => {
        setTaskExec(taskExec);
        fileLogToggle.setVisible(taskExec && true || false);
    }

    return (
        <Area title={<>{title} <EditOutlined onClick={()=>props.editable.edit(props.data)} /></>} toggle={props.toggle}>
            <Layout className='h-100'>
                <Header>
                    <Row>
                        <Col md={8} className='task_action_button'>
                            <Button block type="primary" icon={<CaretRightOutlined />} onClick={executeTask}>Start new</Button>
                        </Col>
                        <Col md={8} className='task_action_button'>
                            <Button block type="dashed" icon={<EditOutlined />} onClick={()=>props.editable.edit(props.data)}>Edit</Button>
                        </Col>
                        <Col md={8} className='task_action_button'>
                            <Button block type="dashed" icon={<StopOutlined />}>Stop all</Button>
                        </Col>
                    </Row>
                </Header>
                <Content >
                    {execList.data && execList.data.map((exec) => (
                        <TaskExecPanel key={exec.id} data={exec}  {...readOnly} onShowLog={onShowLog} onShowFileLog={onShowFileLog}/>
                    ))}
                </Content>
            </Layout>

            <TaskExecLog taskExec={taskExec} toggle={logToggle} />
            <TaskExecFileLog taskExec={taskExec} toggle={fileLogToggle}  />

        </Area>
    );

}